import type {
  RequestForCallbackState,
  RequestForCallbackActions,
} from "./types";

const INITIAL_STATE: RequestForCallbackState = {
  loading: false,
  error: false,
  success: false,
};

export default (
  state: RequestForCallbackState = INITIAL_STATE,
  action: RequestForCallbackActions
): RequestForCallbackState => {
  switch (action.type) {
    case "SEND_REQUEST_FOR_CALLBACK": {
      return {
        loading: true,
        error: false,
        success: false,
      };
    }
    case "SEND_REQUEST_FOR_CALLBACK_FAILED": {
      return {
        loading: false,
        error: true,
        success: false,
      };
    }
    case "SEND_REQUEST_FOR_CALLBACK_SUCCESS": {
      return {
        loading: false,
        error: false,
        success: true,
      };
    }
    case "SEND_REQUEST_FOR_CALLBACK_RESET": {
      return {
        loading: false,
        error: false,
        success: false,
      };
    }
    default:
      return state;
  }
};
